import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { consumeAuthCallbackError, friendlyOAuthCallbackError } from "@/lib/authErrors";

/**
 * Surfaces Supabase OAuth redirect errors (duplicate email, denied consent,
 * etc.) once per page load. Mounted inside AuthProvider so every auth route
 * benefits without duplicating hash parsing in Login / Signup / Welcome.
 */
export function AuthOAuthCallbackMount() {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const raw = consumeAuthCallbackError();
    if (!raw) return;

    toast.error(friendlyOAuthCallbackError(raw), { duration: 8000 });
  }, []);

  return null;
}
